import { Suspense } from 'react';
import { Flex } from './UI-CHAKRA/Flex';
import { Spinner } from './UI-CHAKRA/Spinner';
import { DEFAULT_PRIMARY_COLOR } from '../containers/prescription/usePrescription/helpers.mock';

export const SuspenseSpinner = () => {
  return (
    <Flex w={'100%'} h={'100%'} bg={'#fff'} justifyContent={'center'} alignItems={'center'}>
      <Spinner color={DEFAULT_PRIMARY_COLOR} />
    </Flex>
  );
};

export default function withSuspense(Component: React.ComponentType<any>) {
  return function WithSuspense(props: any) {
    return (
      <Suspense fallback={<></>}>
        <Component {...props} />
      </Suspense>
    );
  };
}
